module.exports = __webpack_public_path__ + "img/offers.91d4a269.svg";